module.exports = __webpack_public_path__ + "img/info.3280dbb3.svg";